import { useRef } from "react"
import { motion, useInView } from "framer-motion"
import FraudGif from "../../../assets/face.gif"

const Fraud = () => {
  const sectionRef = useRef(null)
  const imageRef = useRef(null)
  const textRef = useRef(null)
  const firstTextBlockRef = useRef(null)
  const secondTextBlockRef = useRef(null)

  const isImageInView = useInView(imageRef, { once: true, amount: 0.5 })
  const isTextInView = useInView(textRef, { once: true, amount: 0.5 })
  const isFirstTextBlockInView = useInView(firstTextBlockRef, { once: true, amount: 0.5 })
  const isSecondTextBlockInView = useInView(secondTextBlockRef, { once: true, amount: 0.5 })

  return (
    <section ref={sectionRef} className="w-full bg-slate-50">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Radar visual */}
          <motion.div
            ref={imageRef}
            className="w-full lg:w-1/2 flex justify-center"
            initial={{ opacity: 0, x: -100 }}
            animate={isImageInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <img src={FraudGif || "/placeholder.svg"} alt="fraud" className="rounded-xl overflow-hidden" />
          </motion.div>

          {/* Text content */}
          <motion.div
            ref={textRef}
            className="w-full lg:w-1/2 space-y-10"
            initial={{ opacity: 0 }}
            animate={isTextInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <motion.div
              ref={firstTextBlockRef}
              className="space-y-4"
              initial={{ opacity: 0, x: 100 }}
              animate={isFirstTextBlockInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            >
              <div className="flex items-center gap-3">
                <h2 className="text-2xl md:text-3xl font-bold text-red-900">
                  Stay one step ahead of fraud with advanced protection built in
                </h2>
              </div>
              <p className="text-red-700 text-base md:text-lg">
                Vaspay blends automated and human-led fraud checks to shield you from suspicious transactions and costly
                chargebacks.
              </p>
            </motion.div>

            <motion.div
              ref={secondTextBlockRef}
              className="space-y-4"
              initial={{ opacity: 0, x: 100 }}
              animate={isSecondTextBlockInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
            >
              <div className="flex items-center ">
                <h2 className="text-2xl md:text-3xl font-bold text-red-900">
                  Set clear, detailed reports to make accounting, reconciliation, and audits easier
                </h2>
              </div>
              <p className="text-red-700 text-base md:text-lg">
                Understand what drives purchases and stay organized with intuitive dashboards and downloadable reports.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Fraud
